<template>
  <div class="popup">
    <div class="popup_cover"></div>
    <div class="file-upload-popup">
      <div class="popup-header">
        <div class="popup_title">수행상태 변경</div>
        <img src="@/assets/images/close_btn.png" @click="confirmSelection(false)" class="close_icon" />
      </div>
      <div class="popup-body">
        <div class="contents_body">
          <div v-for="(status, index) in statuses" :key="index" class="contents_div" :class="{ selected: selectedStatus === index }" @click="selectStatus(index)">
            <img src="@/assets/icon/check_on.svg" v-if="selectedStatus === index" />
            <img src="@/assets/icon/check_off.svg" v-else />
            <div>{{ status }}</div>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <div class="popup_confirm_btn" @click="confirmSelection(true)">확정</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref, onMounted } from "vue";

const emit = defineEmits(["closePopup"]);
const props = defineProps<{ status: string | null }>();

// 상태 목록과 선택 상태 인덱스 정의
const statuses = ["대기", "착수보고", "중간보고", "완료보고"];
const selectedStatus = ref<number | null>(null);

// 컴포넌트가 마운트될 때 props.status 값을 초기화
onMounted(() => {
  selectedStatus.value = statuses.indexOf(props.status || "");
});

// 상태를 선택할 때 호출되는 함수
const selectStatus = (index: number) => {
  selectedStatus.value = index;
};

// 선택한 상태를 부모 컴포넌트로 emit
const confirmSelection = (flag: boolean) => {
  if (selectedStatus.value !== null) {
    const status = statuses[selectedStatus.value];
    emit("closePopup", { popupType: "status", refresh: flag, selectedData: status });
  } else {
    alert("확정하기 전에 상태를 선택해 주세요.");
  }
};
</script>

<style scoped>
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.popup_cover {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
.file-upload-popup {
  /* Add your styles here */
  left: 50%;
  position: fixed;
  background-color: white;
  width: 330px;
  height: calc(50% - 36px);
  background: white;
  top: calc(50% - 245px);
  left: calc(50% - 115px);
  border-radius: 11px;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  padding: 22px 27px 22px 40px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-body {
  /* margin-top: 10px; */
  padding: 20px 40px;
  height: calc(100% - 127px);
}
.popup-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0px 40px;
  gap: 10px;
}
.popup_confirm_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #282b33;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.close_icon {
  cursor: pointer;
}
.contents_body {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
.contents_div {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 2px solid #eeeeee;
  padding: 20px 15px;
  justify-content: center;
  cursor: pointer;
}
/*  */
.contents_div {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

/* 선택되지 않은 항목에만 hover 스타일 적용 */
.contents_div:not(.selected):hover {
  background-color: #f0f0f0;
}

/* 선택된 항목 스타일 */
.selected {
  background-color: #222957;
  color: white;
  font-weight: bold;
}

.popup_confirm_btn {
  cursor: pointer;
}

.close_icon {
  cursor: pointer;
}
</style>
